import script from "./AlertMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertMobile.vue?vue&type=script&setup=true&lang=js"

import "./AlertMobile.vue?vue&type=style&index=0&id=32a150f9&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32a150f9"]])

export default __exports__